import React, { useEffect, useState } from "react";

import "./style.css";

interface Props {
  textArray: string[];
  margin?: string;
  linkUrl?: string;
  padding?: string;
  clickAble?: boolean;
  textAlign?:
    | "-moz-initial"
    | "inherit"
    | "initial"
    | "revert"
    | "unset"
    | "center"
    | "end"
    | "justify"
    | "left"
    | "match-parent"
    | "right"
    | "start"
    | undefined;
  fs?: string;
  flexGrow?: any;
  color?: string;
  fontWeight?: any;
  wordSpacing?: string;
}

const AnimatedText: React.FC<Props> = ({
  textArray,
  fs,
  fontWeight = "300",
  margin,
  textAlign,
  color,
  flexGrow,
  linkUrl,
  clickAble,
  wordSpacing = "2px",
  padding,
}) => {
  const [greetingIndex, setGreetingIndex] = useState(0);
  const [currentGreeting, setCurrentGreeting] = useState(textArray[0]);


  useEffect(() => {
    setTimeout(() => {
        setCurrentGreeting(textArray[greetingIndex]);
        setGreetingIndex((greetingIndex + 1) % textArray.length);
      }, 3000);
  }, [greetingIndex,textArray]);

 

  return (
    <span
      key={greetingIndex}
      className="blur-animation"
      style={{
        fontSize: fs,
        color,
        fontWeight,
        margin,
        textAlign,
        flexGrow,
        wordSpacing,
        padding,
        cursor: clickAble ? "pointer" : "",
      }}
      onClick={() => clickAble && window.open(linkUrl)}
    >
      {currentGreeting}
    </span>
  );
};
export default AnimatedText;
